(function ($, document, window, undefined) {

    'use strict';

    var Amenities = function(){

        var modal, swiperGallery

        var setupGallery = function(e) {

            var $modalContent = $("[data-js=modal-content]");

            if( $modalContent.children().length < 1 ) {

                var $swiperGallery = $(["<div class=\"swiper-container gallery\" id=\"amenities-gallery\">","<div class=\"swiper-wrapper\"></div>",
                    "<div class=\"swiper-button-prev\"></div>","<div class=\"swiper-button-next\"></div>","</div>"].join(""))
            
                var $dynamicGallery = $("[data-js=dynamic-gallery]").clone()

                $dynamicGallery.children().each(function(){
                    var fullsizeImgUrl = $(this).find(".image").attr("data-fullsize-img");
                    $(this).attr("class", "swiper-slide");
                    console.log(fullsizeImgUrl);
                    $(this).find(".image").css('background-image', 'url("' + fullsizeImgUrl + '")');
                    $swiperGallery.find(".swiper-wrapper").append($(this))
                })
                
                $swiperGallery.appendTo($modalContent)
            }
        }

        var initSwiperGallery = function(e) {            

            swiperGallery = new Swiper('.gallery', {
                initialSlide : $(e.target).closest(".brick").index(),
                spaceBetween: 0,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
            
        }

        var destroySwiperGallery = function(e) {
            
            swiperGallery.destroy(true, true)
            
        }

        var init = function() {

            modal = new window.Frontier.Modal({
                openTrigger : ".brick",
                onAfterOpen : initSwiperGallery,
                onBeforeClose : destroySwiperGallery
            })

            setupGallery()

        }

        return { init }
    }()

    if (!window.Frontier) window.Frontier = {};
        window.Frontier.Amenities = Amenities;

}(jQuery, document, window));
